import { useEffect, useState } from "react";
import LoginService from "../services/LoginService";
import ProductsAPI, { VISITOR_CONFIG } from "../services/ProductsAPI";
import { useAppConfigContext } from "./hooks/AppConfigContext";
import { useFiltersData } from "./hooks/FiltersContext";
import { GeoserverConfigContext } from "./hooks/GeoserverConfigContext";

const GeoserverConfigProvider = GeoserverConfigContext.Provider;

export default function GeoserverConfigContainer({ children }) {
  const appConfig = useAppConfigContext();
  const filters = useFiltersData();
  const [rawGeoserverConfig, setRawGeoserverConfig] = useState(VISITOR_CONFIG);
  const [geoserverConfig, setGeoserverConfig] = useState(rawGeoserverConfig);

  // Get customer custom layers and geoserver config
  useEffect(() => {
    if (!rawGeoserverConfig?.center) {
      const user = LoginService.customerData();
      ProductsAPI.getCustomerBasedLayers(user).then(setRawGeoserverConfig);
    }
  }, [rawGeoserverConfig]);

  useEffect(() => {
    const roles = filters?.dataStore?.selectedProvinces?.map((p) => p.role.split(":")[0].toLowerCase());

    if (roles && appConfig?.name && rawGeoserverConfig?.center) {
      const roleFilteredPointsLayer =
        roles?.map(
          (role) =>
            `bussola:${appConfig.name.toLowerCase()}_customer_app_points_${role}`
        ) ?? [];
      const polygonsLayer =
        roles?.map(
          (role) =>
            `bussola:${appConfig.name.toLowerCase()}_customer_app_polygons_${role}`
        ) ?? [];
      const perimetersLayer =
        roles?.map((role) => `bussola:customer_app_perimeters_${role}`) ?? [];

      setGeoserverConfig({
        ...rawGeoserverConfig,
        perimetersLayer,
        pointsLayer: roleFilteredPointsLayer,
        polygonsLayer,
      });
    }
  }, [appConfig, filters, rawGeoserverConfig]);

  return (
    <GeoserverConfigProvider value={geoserverConfig}>
      {children}
    </GeoserverConfigProvider>
  );
}
